import React from 'react'

function MobileMenu() {
  return (
        <div className="site-mobile-menu site-navbar-target">
            <div className="site-mobile-menu-header">
                <div className="site-mobile-menu-close">
                <span className="icofont-close js-menu-toggle" />
                </div>
            </div>
            <div className="site-mobile-menu-body" />
        </div>
        )
    }

export default MobileMenu
